import React from "react";
import ReactDOM from "react-dom";
import { App } from "components";
import { SnackbarProvider } from 'notistack';
// import i18n (needs to be bundled ;)) 
import './i18n';


ReactDOM.render(<SnackbarProvider maxSnack={3}><App /></SnackbarProvider>, document.getElementById("root"));
